import React from "react";
import MovieClubSuccess from "@components/MovieClubSuccess";
import VersionedLayout from "@components/Wrappers/VersionedLayout/index.js";

const MovieClubSuccessPage = () => {

    return (
        <VersionedLayout>
            <MovieClubSuccess />
        </VersionedLayout>
    );
};

export default MovieClubSuccessPage;
